module.exports = __webpack_public_path__ + "static/media/placeholderListe.29724e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StickyPhone/medias/placeholderListe.jpg
// module id = 199
// module chunks = 0